import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { FastField, Form, Formik } from 'formik';

import { setLineVehicles } from 'app/store/slices/line';

import { Dialog, DialogContent, DialogTitle, Grid, Typography } from '@material-ui/core';

import Loading from 'app/layouts/Loading';
import CustomTextField from '../../components/TextField';
import CustomDateField from '../../components/DateField';
import SaveBox from '../../components/SaveBox';
import { Alert } from '@material-ui/lab';

const today = moment(new Date()).format();

const activateVehicleModalFormInitials = {
    dtInativacao: null,
    deObservacaoInativacao: '',
};

const ActivateVehicleModal = ({ open, onClose, readOnly = false, title, selectedVehicle }) => {
    const dispatch = useDispatch();

    const [loadingInactivation] = useState(false);
    const [formInitials, setFormInitials] = useState(activateVehicleModalFormInitials);

    const lineVehicles = useSelector((state) => state.line.lineVehicles);

    useEffect(() => {
        if (selectedVehicle && Object.keys(selectedVehicle).length > 0) {
            const selectedVehicleInitials = {
                dtInativacao: selectedVehicle?.dtInativacao || today,
                deObservacaoInativacao: selectedVehicle?.deObservacaoInativacao || '',
            };
            setFormInitials(selectedVehicleInitials);
        }
    }, [selectedVehicle]);

    const handleSubmitActivation = async (values) => {
        const modifiedCopy = lineVehicles?.map((stateVehicle) => {
            if (stateVehicle.cdVeiculo === selectedVehicle.cdVeiculo) {
                return { ...stateVehicle, ...selectedVehicle, ...values, boAtivo: false };
            }
            return stateVehicle;
        });

        dispatch(setLineVehicles(modifiedCopy));
        onClose();
    };

    return (
        <Dialog fullWidth maxWidth="md" open={open} onClose={onClose} scroll="body">
            <Formik validateOnBlur enableReinitialize initialValues={formInitials} onSubmit={handleSubmitActivation}>
                {(formProps) => (
                    <Form>
                        {loadingInactivation && <Loading />}
                        <DialogTitle onClose={onClose} disableTypography>
                            <Typography color="secondary" variant="subtitle2">
                                {title}
                            </Typography>
                        </DialogTitle>
                        <DialogContent dividers>
                            <Grid container spacing={4}>
                                <Grid item xs={12} sm={4}>
                                    <FastField
                                        component={CustomDateField}
                                        label="Data"
                                        name="dtInativacao"
                                        disabled={readOnly}
                                        inputProps={{
                                            maxLength: 2000,
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <FastField
                                        component={CustomTextField}
                                        label="Observação"
                                        name="deObservacaoInativacao"
                                        multiline
                                        minRows={4}
                                        inputProps={{
                                            maxLength: 2000,
                                            readOnly: readOnly,
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    {!readOnly && (
                                        <Alert severity="warning">
                                            Ao inativar este veículo, o CEPE vigente será cancelado.
                                        </Alert>
                                    )}
                                </Grid>
                                <Grid item xs={12}>
                                    <SaveBox
                                        onCancel={onClose}
                                        firstButtonLabel={readOnly ? 'Fechar' : 'Cancelar'}
                                        middleButtonLabel={!readOnly ? 'salvar' : null}
                                        onSave={formProps.handleSubmit}
                                        removeSpacing
                                    />
                                </Grid>
                            </Grid>
                        </DialogContent>
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
};

export default ActivateVehicleModal;
